<template>
  <a-card class='mb15'>
    <div class="s_flex_bian_c">
      <div class="s_flex_ali">
        <img class="width-20 height-20 m-r-10" src="../assets/images/data.png" alt="">
        <p class="s_font_b fz-18 s_c000">概况</p>
      </div>
      <a-form ref='form' :model='search' :initialValues="search" layout='inline' :onFinish='getStatisticsData'>
        <a-form-item>
          <a-radio-group button-style="solid" @change="onChangeRadio" v-model:value="search.recent_day_nums">
            <a-radio-button :value="7">近7天</a-radio-button>
            <a-radio-button :value="30">近30天</a-radio-button>
            <a-radio-button :value="2">月</a-radio-button>
            <a-radio-button :value="3">年</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="" v-if='search.recent_day_nums==2'>
          <a-month-picker v-model:value="month" valueFormat='YYYY-MM' format='YYYY-MM' placeholder="请选择月份" @change="onChangeMonth" />
        </a-form-item>
        <a-form-item label="" v-if='search.recent_day_nums==3'>
          <a-select
            v-model:value="search.year"
            style="width: 150px"
            @change="onChangeYear"
            placeholder="请选择年份"
          >
            <a-select-option v-for='(item,index) in yearArr' :key='index' :value="item">{{item}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="">
          <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChangeRange" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
      </a-form>
    </div>
    <a-divider />
    <div class="s_flex_bian_c">
      <div class="s_flex_bian_c width46 s_bor_cb4c s_bor5 s_over">
        <div class="width35 p-30 s_shou" :class='search.stat_type == "brandStat" ? "s_bf5f":""' @click='tabBnt("brandStat","新增品牌商")'>
          <p class="fz-16 s_c000">品牌商总数</p>
          <p class="s_font_b s_c000 fz-30 m-t-12 m-b-12">{{brand_total.total_count || 0}}</p>
          <div class="s_c999 height-22">
            <div class="s_flex_ali" v-if='brand_total.time_range_count > 0'>
              <p>期间增长</p>
              <span class="balanceUp m-l-5 m-r-5">{{brand_total.time_range_count || 0}}</span>
              <img class="width-10 height-16" src="../assets/images/up.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="width14">
        <div class="height-80 s_bor_cb4c s_bor5 m-b-20 s_flex_ali s_over">
          <div class="fz-16 s_c000 height-80 width-40 s_flex_center s_c376" style="background-color: #B5C3D2;">
            <p class="width-30 s_text_c">续费期</p>
          </div>
          <p class="s_font_b balanceUp fz-30 width83 s_text_c">{{brand_renewal_total.total_count || 0}}</p>
        </div>
        <div class="height-80 s_bor_cb4c s_bor5 s_flex_ali s_over">
          <div class="fz-16 s_c000 height-80 width-40 s_flex_center s_c376" style="background-color: #B5C3D2;">
            <p class="width-30 s_text_c">已过期</p>
          </div>
          <p class="s_font_b s_c000 fz-30 width83 s_text_c">{{brand_expire_total.total_count || 0}}</p>
        </div>
      </div>
    </div>
    <div class="m-t-30">
      <a-spin :spinning="listLoading">
        <echartLine :echartsData='echartsData' v-if='!listLoading'></echartLine>
      </a-spin>
    </div>
  </a-card>


</template>
<script>
  import { reactive, ref, toRefs, onMounted, inject } from "vue";
  import { getStatisticsIndex,getRankIndex,getRankSysApps,getRankSms } from "@/api/index";
  import { $iscode } from "@/utils/app";
  import { message } from "ant-design-vue";
  const defSearch = {
    start_time: "",
    end_time: "",
    recent_day_nums: 7,
    year:null,
    month:'',
    stat_type:'brandStat'
  };
  export default {
    name: "Home",
    setup() {
      let search = ref({ ...defSearch });
      const state = reactive({
        tableLoading:true,
        listLoading: true,
        echartsData: {},
        echarts_name:'新增品牌商',
        brand_total: {},
        agent_count:{},
        commission_total:{},
        brand_renewal_total:{},
        brand_expire_total:{},
        sms_sales_brand_rank:[],
        sys_apps_sales_rank:[],
        data:[],
        time: [],
        month:'',
        yearArr:[]
      });
      const columns = [
        {
          dataIndex: "name",
          key: "name",
          slots: { title: 'nameTitle' },
        },
        {
          title: "销量(个)",
          dataIndex: "sale_count",
          key: "sale_count",
        },
      ]
      // 单选
      const onChangeRadio = (e) => {
        search.value.start_time = "";
        search.value.end_time = "";
        state.time = [];
      };
      // 选择时间段
      const onChangeRange = (e) => {
        search.value.start_time = e[0];
        search.value.end_time = e[1];
        search.value.recent_day_nums = ''
        search.value.year = ''
        search.value.month = ''
      };
      //选择月份
      const onChangeMonth = (e) =>{
        search.value.start_time = "";
        search.value.end_time = "";
        state.time = [];
        search.value.year = ''
        search.value.month = e.split('-')[1]
      };
      //选择年
      const onChangeYear= (e) =>{
        search.value.start_time = "";
        search.value.end_time = "";
        state.time = [];
        search.value.month = ''
        search.value.year = e
      };
      // 
      const tabBnt = (e,text) =>{
        state.echarts_name = text
        search.value.stat_type = e
        getStatisticsData()
      }
      const getStatisticsData = async() =>{
        let res = await getStatisticsIndex(search.value).then(res => res.data);
        if ($iscode(res)) {
          state.brand_total = res.data.brand_total;
          state.agent_count = res.data.agent_count;
          state.commission_total = res.data.commission_total;
          state.brand_renewal_total = res.data.brand_renewal_total;
          state.brand_expire_total = res.data.brand_expire_total;
          state.echartsData = {...res.data.statistics,name:state.echarts_name}
        } else {
          message.error(res.msg);
        }
        state.listLoading = false;
      }
      const getRankData = async() =>{
        let res = await getRankIndex().then(res => res.data);
        if ($iscode(res)) {
          state.sms_sales_brand_rank = res.data.sms_sales_brand_rank.data;
          state.sys_apps_sales_rank = res.data.sys_apps_sales_rank.data
        } else {
          message.error(res.msg);
        }
        state.tableLoading = false;
      }
      onMounted(() => {
        getStatisticsData()
        getRankData()

        var nfOptionsArray = new Array();
        var years= new Date().getFullYear();
        for(var i=years-5;i<=years+5;i++){
          nfOptionsArray.push(i);
        }
        state.yearArr = nfOptionsArray
      });
      return {
        ...toRefs(state),
        search,
        columns,
        onChangeRadio,
        onChangeRange,
        onChangeMonth,
        getStatisticsData,
        getRankData,
        onChangeYear,
        tabBnt
      };
    },
  };
</script>
<style>
  .balanceUp {
    color: #DF412C;
  }

  .balanceDown {
    color: #4BB339;
  }
</style>